import {configureStore} from "@reduxjs/toolkit";
// import categoriesSlice from "./categoriesSlice";
import {createLogger} from "redux-logger";
import securitySlice from "./securitySlice";
import currencySlice from "./currencySlice";
import categorySlice from "./categorySlice";
import walletSlice from "./walletSlice";
import transactionSlice from "./transactionSlice";
import budgetSlice from "./budgetSlice";
import templateSlice from "./templateSlice";
import userSettingsSlice from "./userSettingsSlice";
// import securitySlice from "./securitySlice";
// import productsSlice from "./productsSlice";
// import cartsSlice from "./cartsSlice";

const logger = createLogger({
    // ...options
});
const store = configureStore({
    reducer: {
        categorySlice: categorySlice,
        securitySlice: securitySlice,
        currencySlice: currencySlice,
        walletSlice: walletSlice,
        transactionSlice: transactionSlice,
        budgetSlice: budgetSlice,
        templateSlice: templateSlice,
        userSettingsSlice: userSettingsSlice
        // productsSlice: productsSlice,
        // cartsSlice: cartsSlice
    },
    middleware: (getDefaultMiddleware) => getDefaultMiddleware().concat(logger),
})

export default store;